import SuspenseWrapper from './suspense-wrapper';

export default SuspenseWrapper;
